export default __webpack_public_path__ + "static/media/xai.d303fd7f.jpg";